import { useState, useEffect } from 'react';
import axios from 'axios';
import './Donate.css';
import PropTypes from 'prop-types';

export function DonationOptions({ setIsMe, isMe, setIsBehalf, isBehalf, setIsMemorial, isMemorial, setFormTitle, bindInMemoryName, bindOccasion }) {
  const [error, setError] = useState();
  const [occasions, setOccasions] = useState([]);

  useEffect(() => {
    const populateOccasions = async () => {
      try {
        await axios.get(`/occasion`)
          .then((response) => {
            if (response.data != null) {
              response.data.unshift('');
              setOccasions(response.data);
            }
          });
      } catch (e) {
        setError(e.message);
      }
    }

    populateOccasions();

  }, []);

  const myChangeHandler = (e) => {
    const target = e.currentTarget;

    if (target.id === "Me") {
      setIsMe(true);
      setIsBehalf(false);
      setIsMemorial(false);
      setFormTitle("My Information");
    } else if (target.id === "Behalf") {
      setIsMe(false);
      setIsBehalf(true);
      setIsMemorial(false);
      setFormTitle("Payee Information");
    } else if (target.id === "Memorial") {
      setIsMe(false);
      setIsBehalf(false);
      setIsMemorial(true);
      setFormTitle("Payee Information");
    }
  }

  if (error)
    return (<h2><b>Problem loading occasions: {error}</b></h2>);
  else {
    return (
      <div>
        <h2 style={{ paddingTop: "5px" }}>Select Your Gifting Option</h2>
        <div className="form-group">
          <div className="radio">
            <label className="control-label">
              <input type="radio" name="donationType" id="Me" value="me" checked={isMe} onChange={myChangeHandler} />
              This donation is in my name
            </label>
          </div>
          <div className="radio">
            <label className="control-label">
              <input type="radio" name="donationType" id="Behalf" value="behalf" checked={isBehalf} onChange={myChangeHandler} />
              This donation is on behalf of a supporter for:
              <select id="Occasion" className="form-select in-line-control" name="Occasion" {...bindOccasion}>
                {occasions.map((occasion, i) => (<option key={i} value={occasion.name}>{occasion.name}</option>))}
              </select>
            </label>
          </div>
          <div className="radio">
            <label className="control-label">
              <input type="radio" name="donationType" id="Memorial" value="memorial" checked={isMemorial} onChange={myChangeHandler} />
              This donation is a memorial for <input id="MemorialName" className="form-control in-line-control" name="In memory of" type="text" {...bindInMemoryName} />
            </label>
          </div>
        </div>
      </div>
    );
  }
}

DonationOptions.propTypes = {
  setIsMe: PropTypes.func.isRequired,
  setIsBehalf: PropTypes.func.isRequired,
  setIsMemorial: PropTypes.func.isRequired,
  setFormTitle: PropTypes.func.isRequired,
  isMe: PropTypes.bool.isRequired,
  isBehalf: PropTypes.bool.isRequired,
  isMemorial: PropTypes.bool.isRequired,
  bindInMemoryName: PropTypes.object.isRequired,
  bindOccasion: PropTypes.object.isRequired
}

